import { COMMON_METABASE_CONFIG } from "@common-shared/config/metabase.config"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config"

import { IMetabaseTheme } from "../types/metabase.types"

export const METABASE_CONFIG = {
    ...COMMON_METABASE_CONFIG,

    instanceUrl: "https://dashboards.meetnirvana.net",

    get theme(): IMetabaseTheme {
        return {
            colors: {
                brand: NIRVANA_COLORS.brand.primary,
                "text-primary": NIRVANA_COLORS.brand.primary,
                background: NIRVANA_COLORS.brand.offWhite,
                "background-disabled": "rgb(238, 232, 226)",
                "background-secondary": "rgb(239, 234, 229)",
                "text-secondary": "rgb(57, 40, 90)",
                "text-tertiary": "rgb(70, 50, 110)",
                "brand-hover": "rgb(62, 43, 97)",
                "brand-hover-light": "rgb(70, 50, 110)",
            },
        }
    },
}
